export const LocaleEn = {
  memo: {
    draftRevived: 'Do you want to retrieve draft?',
    draftRevived2: 'Do you want to retrieve autosaved draft?',
    save: 'Will save and Send your Memo',
    draft_save: 'Save as DRAFT',
    title: 'Title',
    title_blank: 'Title empty',
    message: 'Text',
    memo_tag: 'Tags',
    brand: 'Company name',
    investment: 'Rating',
  },
  sign: {
    redIncrease: 'L-widen',
    redDecrease: 'L-shrank',
    changeRed: 'Turn Loss',
    changeBlack: 'Turn Prof',
  },
  histogram: {
    yourEst: 'Est',
    consensus: 'Con',
    alertText: 'Please re-enter your forecast for the period you want to display'
  },
  chat: {
    banner: 'Chat',
    placeHolder: 'Enter message here... (Ctrl+Enter to send) *Name registration',
    submitBtn: 'Send',
    BBS: 'Public',
    channel: 'Channel',
    DM: 'DM',
    follow: 'Follow',
    follower: 'Follower',
    createChannel: {
      promptMsg: 'Enter new Channel Name...(Max 20 chars)',
      alert: 'Please limit Channel name within 20 characters',
    },
    channelUser: 'Members',
    addChannelUser: 'Add to Channel?',
    deleteChannel: 'Delete {{channelName}} channel?',
    deleteMessage: 'Delete message?',
    transmissionTime: {
      aFewSecondAgo: 'few sec ago',
      secondsAgo: 'sec ago',
      withinOneMinute: 'within 1min',
      minutesAgo: 'min ago',
      withinOneHour: 'within 1hr',
      hoursAgo: 'hours ago',
      yesterday: 'yesterday',
      daysAgo: 'days ago',
    },
  },
  ticker: {
    targetPrice: {
      alertText: 'Failed to update the target price',
    }
  },
  addTickerToCoverage: {
    error: {
      alreadyAdded: 'Already added.',
      notExist: 'The targeted group does not exist.'
    }
  },
  stockChart: {
    title: 'Share Price・{{ bar }}・PER',
    titleUs: 'Share Price',
    yAxis: {
      label: { 
        JP: 'Stock Price(JPY)',
        US: 'Stock Price(USD)'
      },
      billion: '(JPY bn)',
      yen: '(JPY)'
    },
    barType: {
      revenue: 'Revenues',
      gp: 'Gross Profit',
      op: 'OP',
      ebt: 'EBT',
      income: 'NP',
      dps: 'DPS',
    }
  },
  targetStockList: {
    label: {
      targetDate: 'Target Date',
      stock: 'Price',
      tpHi: 'Target',
      tpLow: 'Risk'
    },
    btn: {
      save: 'Save',
      saved: 'Saved',
      delete: 'Delete'
    },
    errors: {
      eitherOneHasValue: 'Please enter value in Target&Risk *Risk can be blank',
      maximumGreaterThanMinimum: 'Enter values as follows: Target >= Risk',
      moreMinorityOrLess: 'TP is limited to 2 decimal place and should be higher than 1',
      blankTargetData: 'Please enter Target Date',
      afterToday: 'Please enter future date *You can only delete past entries',
      upToFiveYears: 'You may set TP upto 5 years',
      alreadyExist: '{{ targetDate }} already exists',
      failedToSave: 'Could NOT be saved',
      failedToDelete: 'Could NOT be deleted'
    }
  },
  trackerChart: {
    actual: 'Actual',
    guidance: 'Guidance',
    fix: 'Guidance',
    estimation: 'Forecast',
    published_at: 'Report date',
    type: {
      revenue: 'Revenues (bn JPY)',
      op: 'OP (bn JPY)',
      rp: 'RP (bn JPY)',
      ebt: 'EBT (bn JPY)',
      income: 'NP (bn JPY)',
      eps: 'EPS (JPY)',
      dps: 'DPS (JPY)'
    }
  },
  relativeChart: {
    yAxis: {
      label: '% Change',
    },
    error: {
      blank: 'Choose two companies or custom indices to compare',
      takingLonger: 'It is taking longer than usual. Please come back later'
    }
  },
  customIndex: {
    btn: {
      calculating: 'Calculating...',
      update: 'Recalculate and Update Graph'
    },
    selectBox: {
      added: 'Add',
      deleted: 'Remove',
    },
    flash: {
      finishCalculation: 'Finished calculation',
      error: 'There was an error during calculation',
      takingLonger: 'It is taking longer than usual. Please come back later'
    },
    error: {
      failedCalucualtion: 'There was an error during calculation. Please contact us at contact@gyoseki.com'
    },
    graph: {
      xAxis: 'Date',
      yAxis: 'Index',
      tooltip: {
        label: '% Change',
      }
    }
  },
  embed: {
    sc: {
      yAxis: {
        label: 'Stock Price(JPY)',
        billion: '(JPY bn)'
      },
      profitType: {
        op: 'OP',
        rp: 'RP',
        ebt: 'EBT'
      }
    }
  },
  financials: {
    thHover: {
      close: 'Click to hide quarterly data',
      open: 'Click to display quarterly data'
    }
  },
  longTermEstimation: {
    btn: {
      save: 'Save',
      saving: 'Saving...',
      saved: 'Saved',
    },
    error: {
      failed: 'Failed to save'
    },
    validation: {
      blankTerm: 'Please complete {{ dateStr }} projections.'
    }
  },
  team: {
    team_members: 'Members...',
    team_name: 'User Name',
    privilege: 'Privilege',
    gyoseki_id: 'Gyoseki ID',
    status: 'Status',
    lock: 'Lock',
    show_members: 'Show Members',
    showing_members: 'Showing',
  }
};
